import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { IRecord, IRecordTypeDefinition } from '@platform/core/types';
import { TEXT_MAX, validateDraft } from './validateDraft';

/**
 * Перевірка чернетки перед збереженням з повідомленнями мовою інтерфейсу (ключ поля → текст помилки); `all` — обов'язкові поля
 * перевіряються всі, не лише змінені (новий запис).
 */
export function useDraftValidator(rt: IRecordTypeDefinition, record: IRecord | undefined, all = false): (draft: Record<string, unknown>) => Record<string, string> {
  const { t } = useTranslation();
  return useCallback((draft: Record<string, unknown>) => Object.fromEntries(Object.entries(validateDraft(rt, record, draft, all))
    .map(([k, code]) => [k, t(`recordPage.errors.${code}`, { max: TEXT_MAX })])), [rt, record, all, t]);
}
